module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-community-organized.svg?6659cd448c72ded0c6f5b831fa5891de";